import React, {PureComponent as Component} from 'react'; 
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import ShowInvertFriend from "../../Friend/Controllers/ShowInvertFriend";
import ShowInsertMosavabat from "../Layout/ShowInsertMosavabat";
import ShowPictursBox from "../../Post/Controllers/ShowPictursBox";
import ShowFollowingBox from "../../Friend/Controllers/ShowFollowingBox";
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import Child from "../../../../ui/template/Children/Child";
import AppConfig from "../../../Controllers/AppConfig";
import MosavabatState from "./All/MosavabatState";

var ps=new MosavabatState();

class   Mosavabats extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HfunCV=this.funCV.bind(this);
        this.props=props;
    }

    funCV(data,ts,recordKey,selectFun=null){
        let rows=[];
        let l=data.length;
        let state=null;
        for (let i=0;i<l;i++){
            this.rowsId++;
            state = ps.getValueItem(data[i].state);
            let el=  <div className="p-3 d-flex align-items-center border-bottom osahan-post-header">
                <div className="dropdown-list-image mr-3">
                    <img className="rounded-circle" src="http://mdyaran.ir/membership/picture" alt="" />
                </div>
                <div className="font-weight-bold mr-3">
                    <div className="text-truncate">
                        <span   className="badge badge-info">عنوان</span>
                        <span className="text-primary pl-2 font-10">
                                              {data[i].title}
                        </span>
                    </div>
                    <div className="small">
                        {data[i].description}
                    </div>
                    <span   className="badge badge-primary">
                         {state}
                    </span>
                </div>
            </div>    ;
            rows.push(el);
        }
        ts.cv=<><div className="w-100 mt-2 mb-4 d-block"> {rows} </div></>;
    }



    componentDidMount(){
        let page = this.context.page;
        this.context.page.pageTitle.setTitle(" مصوبات جلسات ");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) {
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("mosavabats");
                this.context.page.pageBreadcrumbs.current.show();
            }
        }
    }

   

    render() {

        return (
            <div className="row">
                <main className="col col-xl-6 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12">
                    <div className="box shadow-sm border rounded bg-white mb-3">
                        <div className="box-title border-bottom p-3">
                            <h6 className="m-0">
                               لیست مصوبات جلسات
                            </h6>
                        </div>
                        <div className="box-body p-0">

                            <DataLoader ref={this.table1} scope="route" name="mosavabat"
                                        baseUrl={AppConfig.base_url} orderColumn={5} orderDir={2}
                                        srcName="mosavabat" getBoxItem={ this.HgetBoxItem} selectable={false}
                                        funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                                        queryFields="id,state,createdAt,title,description">
                                <Child type="navbar">

                                </Child>
                                <Child type="links">

                                </Child>
                            </DataLoader>
                        </div>
                    </div>
                </main>
                <aside className="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-6 col-12 side-sticky">
                    <ShowProfile  />
                    <ShowInvertFriend />
                </aside>
                <aside className="col col-xl-3 order-xl-3 col-lg-6 order-lg-3 col-md-6 col-sm-6 col-12 side-sticky">
                    <ShowFollowingBox />
                    <ShowPictursBox />
                    <ShowInsertMosavabat />
                </aside>
            </div>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Mosavabats.contextType = MCbrowser;

export default Mosavabats;
